import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {Loader} from "../../../../components/admin/Loader";
import {CollectionForm} from "../../../../components/admin/equipment/CollectionForm";
import {collectionResultType} from "../../../../types/Api/CollectionResultType";
import {collection} from "../../../../models/collection";
import {collectionHydrator} from "../../../../models/hydrator/collectionHydrator";
import {BoxTitle} from "../../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [collection, setCollection] = useState(undefined as undefined | collection);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/collection/${uuid}`) as Promise<collectionResultType>;

      setLoading(true);

      result
        .then((r) => {
          setCollection(collectionHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (collection || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier une collection' : 'Ajouter une collection'}/>
          <CollectionForm collection={collection} />
        </>
      )}
    </>
  );
}
